"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Menu_1 = __importDefault(require("@material-ui/core/Menu"));
const usePrevious_1 = __importDefault(require("../../hooks/usePrevious"));
require("../../styles/components/nested-menu-item.less");
let softCloseTimer;
const MAX_MENU_WIDTH = 380;
const MENU_MARGIN = 4;
const NestedMenuItem = (props) => {
    const { parentMenuOpen = true, label, children, className, tabIndex: tabIndexProp, ContainerProps: ContainerPropsProp = {}, disabled, forceClose, ...MenuItemProps } = props;
    const { ref: containerRefProp, ...ContainerProps } = ContainerPropsProp;
    const menuItemRef = (0, react_1.useRef)(null);
    const containerRef = (0, react_1.useRef)(null);
    const menuContainerRef = (0, react_1.useRef)(null);
    const [isSubMenuOpen, setIsSubMenuOpen] = (0, react_1.useState)(false);
    const [autoClose, setAutoClose] = (0, react_1.useState)(true);
    const handleMouseEnter = (event) => {
        if (!disabled) {
            clearTimeout(softCloseTimer);
            setIsSubMenuOpen(true);
            if (ContainerProps?.onMouseEnter) {
                ContainerProps.onMouseEnter(event);
            }
        }
    };
    const handleMouseLeave = (event) => {
        if (!autoClose) {
            setIsSubMenuOpen(true);
        }
        else {
            softCloseTimer = setTimeout(() => {
                setIsSubMenuOpen(false);
            }, 300);
        }
        // close of nested-menu-item
        if (ContainerProps?.onMouseLeave) {
            ContainerProps.onMouseLeave(event);
        }
    };
    const handleFocus = (event) => {
        setAutoClose(false);
        if (event.target === containerRef.current) {
            setIsSubMenuOpen(true);
        }
        if (ContainerProps?.onFocus) {
            ContainerProps.onFocus(event);
        }
    };
    const open = isSubMenuOpen && parentMenuOpen && !forceClose;
    // Root element must have a `tabIndex` attribute for keyboard navigation
    let tabIndex;
    if (!disabled) {
        tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    }
    const handleOnClose = (0, react_1.useCallback)(() => setIsSubMenuOpen(false), []);
    const enforceFocus = (0, react_1.useCallback)(() => setAutoClose(false), []);
    const windowSize = (0, usePrevious_1.default)();
    const boundingClientReactToRight = containerRef?.current?.getBoundingClientRect()?.right;
    const openToRight = (0, react_1.useMemo)(() => !(windowSize.width - boundingClientReactToRight < MAX_MENU_WIDTH), [boundingClientReactToRight, windowSize.width]);
    const menuStyle = {
        pointerEvents: 'none',
        marginLeft: openToRight ? MENU_MARGIN : -MENU_MARGIN,
    };
    const anchorOrigin = {
        vertical: 'top',
        horizontal: openToRight ? 'right' : 'left',
    };
    const transformOrigin = {
        vertical: 'top',
        horizontal: openToRight ? 'left' : 'right',
    };
    return (react_1.default.createElement("div", { ...ContainerProps, ref: containerRef, onFocus: handleFocus, tabIndex: tabIndex, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave },
        react_1.default.createElement("div", { ...MenuItemProps, ref: menuItemRef }, label),
        react_1.default.createElement(Menu_1.default, { className: "nested-menu-item", 
            // Set pointer events to 'none' to prevent the invisible Popover div
            // from capturing events for clicks and hovers
            style: menuStyle, anchorEl: menuItemRef.current, anchorOrigin: anchorOrigin, transformOrigin: transformOrigin, open: open, autoFocus: false, disableAutoFocus: true, disableEnforceFocus: true, onClose: handleOnClose, transitionDuration: { appear: 200, enter: 100, exit: 200 } },
            react_1.default.createElement("div", { ref: menuContainerRef, className: "nested-menu-item-container" }, react_1.default.cloneElement(children, { enforceFocus })))));
};
exports.default = NestedMenuItem;
//# sourceMappingURL=nested-menu-item.js.map